/**
 * Created by lari on 03/05/2017.
 */
/* either pass list of drugs (patdrugss) to dispay or load drugs/patdrugss depending on mode */


(function () {
  'use strict';
  angular.module('vcdrug')
    .component('drugcurrent', {
      restrict: 'E',
      bindings: {
        patientid: '<'
      },
      template: `
    <h4>Aktuelle Medikamente</h4>
    <div class="input-group">
      <div class="alert alert-info" ng-show="vm.ready === 'loading'">
        <i class="fa fa-spinner fa-spin"></i> Medikation wird geladen ...
      </div>
      <div class="alert alert-info" ng-show="vm.activecount === 0 && vm.totalcount > 0">
        <i class="fa fa-info-circle"></i> Keine aktuelle Medikation gefunden!
      </div>
      <div class="alert alert-info" ng-show="vm.activecount === 0 && vm.totalcount === 0">
        <p><i class="fa fa-info-circle"></i> Keine Medikation gefunden!</p>
        <!--<p ng-show="vm.state.indexOf('drug') < 0"><i class="fa fa-lightbulb-o"></i> Sie können Medikamente unter dem
          <a ui-sref="patientrecord.drugs(vm.params)">Karteireiter Medikamente</a> verordnen und dokumentieren.</p>-->
      </div>
      <span ng-repeat="drug in vm.patdrugs.drugs" id="quuxbar">
        <span ng-show="drug.active && vm.datecheck(drug)" uib-dropdown>
          <button type="button" class="btn btn-{{drug.color}}" uib-dropdown-toggle
                  ng-class="{'btn-outline': drug.foreign}"
                  data-toggle="uib-dropdown" aria-haspopup="true" aria-expanded="false"
                  uib-tooltip="{{drug.name}} / {{drug.amount}} / {{drug.privcomment}}">
            {{drug.name | drugname }} {{drug.amount}}  <i ng-show="drug.converted" class="fa fa-retweet"></i> <span class="caret"></span>
          </button>
          <ul uib-dropdown-menu>
            <li>
              <a ng-click="vm.updateDrugColor(drug, 'success')">
                <span class="label label-success">Grün (Erfolg)</span>
              </a>
            </li>
            <li>
              <a ng-click="vm.updateDrugColor(drug, 'warning')">
                <span class="label label-warning">Gelb (Warnung)</span>
              </a>
            </li>
            <li>
              <a ng-click="vm.updateDrugColor(drug, 'danger')">
                <span class="label label-danger">Rot (Gefahr)</span>
              </a>
            </li>
            <li>
              <a ng-click="vm.updateDrugColor(drug, 'info')">
                <span class="label label-info">Türkis (Information)</span>
              </a>
            </li>
            <li>
              <a ng-click="vm.updateDrugColor(drug, 'primary')">
                <span class="label label-primary">Blau (Aktuell)</span>
              </a>
            </li>
    
            <li>
              <a ng-really-message="Dieses Medikament wirklich absetzen?"
                 ng-really-click="vm.deactivateDrug(drug)">
                <span class="label label-danger">X</span> Medikament absetzen
              </a>
            </li>
            <li role="separator" class="divider"></li>
              <form id="commentform">
              <label for="dcomment">Kommentar</label>
              <textarea class="form-control dropdown" ng-model="drug.privcomment" id="dcomment"
                     ng-click="$event.stopPropagation()"
                     ng-blur="vm.save()"></textarea>
              </form>
            </li>
            <li role="separator"   ng-show="drug.fi" class="divider"></li>
            <li ng-show="drug.fi"><a
                   href="/routes{{drug.fi}}" target="_blank"
                   uib-tooltip="Fachinformationen"><span class="fa fa-file-pdf-o btn btn-info btn-sm"></span> Fachinformationen</a></li>
          </ul>
        </span>
      </span><!-- ng-repeat -->
    </div>
  `,
      controllerAs: 'vm',
      controller: ['$log', 'Rlog', 'Drug', 'vertxEventBusService', '$state',
        function ($log, Rlog, Drug, vertxEventBusService, $state) {
          let vm = this;
          vm.deactivateDrug = deactivateDrug;
          vm.updateDrugColor = updateDrugColor;
          vm.datecheck = datecheck;
          vm.save = save;

          $log.debug('[vcdrug][drugcurrent] state in drugcurrent: ', $state);
          vm.state = $state.current.name;
          vm.params = $state.current.params;

          vm.ready = 'loading';

/*          vm.$onInit = function () {
            if (angular.isDefined(vm.patientid) && vm.patientid.length > 0) {
              Drug.$searchBy('patientid', vm.patientid).$then(function (drugs) {
                vm.patdrugs = drugs[0];
                calcdrugs(vm.patdrugs);
              });
            }
          };*/


          // vm.patientid might be late propagating, get files on first change
          vm.$onChanges = function (changes) {
            if (angular.isDefined(changes.patientid) && angular.isDefined(changes.patientid.currentValue)
                && changes.patientid.currentValue.length > 0) {
              vm.patientid = changes.patientid.currentValue;
              getPatdrugs();
            }
          };

          function getPatdrugs () {
            Drug.$searchBy('patientid', vm.patientid).$then(function (drugs) {
              $log.info('[vcdrug][drugcurrent] retrieved existing patdrug record: ', drugs);
              vm.patdrugs = drugs[0];
              $log.debug('[vcdrug][drugcurrent] vm.patdrugs: ', vm.patdrugs);
              calcdrugs(vm.patdrugs);
              $log.debug('[vcdrug][drugcurrent] fixed vm.patdrugs: ', vm.patdrugs);

            });
          }



          // patientid might be late on propagating
          function calcdrugs(drugs) {
            vm.ready = 'done';
            if (angular.isDefined(drugs) && angular.isDefined(drugs.drugs)) {
              vm.totalcount = drugs.drugs.length;
              let saveneeded = 0;
              for (let i = 0; i < drugs.drugs.length; i++) {
                // deactivate expired "once-off" drugs
                if (drugs.drugs[i] && drugs.drugs[i].active && drugs.drugs[i].endDate && drugs.drugs[i].endDate < moment().toISOString()) {
                  drugs.drugs[i].active = false;
                  drugs.drugs[i].print = false;
                  saveneeded++;
                }
                if (saveneeded > 0) {
                  vm.save();
                }
              }
            }
            else {
              vm.activecount = 0;
              vm.totalcount = 0;
            }

          }

          function updateDrugColor(drug, color) {
            drug.color = color;
            vm.save();
          }

          function datecheck(drug) {
            return !moment(drug.endDate).isBefore(moment());
          }

          function deactivateDrug(drug) {
            drug.active = false;
            drug.print = false;
            drug.endDate = moment().toISOString();
            vm.save();
          }


          function save() {
            if (vm.patdrugs.$hasPendingActions()) {
              vm.patdrugs.$cancel();
            }
            vm.patdrugs.$save();
          }

          const patdrugsUpdateHandler = function (message) {
            // $log.debug('debug: Client update received: ', message);
            let messages = message.split(':');
            // if (angular.isDefined(vm.patdrugs) && angular.isDefined(vm.patdrugs._id) && vm.patdrugs._id === messages[0]) {
            if (angular.isDefined(vm.patdrugs) && angular.isDefined(vm.patdrugs._id)) {
              vm.patdrugs.$refresh().$then(function (drugs) {
                calcdrugs(drugs);
                $log.debug('[vcdrug][drugcurrent] refreshed patdrugs for patdrugs: ', vm.patientid);
              }, function (error) {
                $log.error(error);
                $log.debug('[vcdrug][drugcurrent] refreshing patdrugs for patdrugs failed: ', error, vm.patientid);
              });
            } else {
              getPatdrugs();
            }
          };

          vertxEventBusService.on('patdrugs.update', {}, patdrugsUpdateHandler);



          vm.$onDestroy = function () {
            vertxEventBusService.unregisterHandler('patdrugs.update', {}, patdrugsUpdateHandler);
          };

        }] // controller
    }); // component

  // klammerfriedhof
}());
